import { useEffect, useState } from "react";
import axios from "axios";

const StructureViewer = ({ materialId }) => {
  const [cifContent, setCifContent] = useState("");
  const [cifUrl, setCifUrl] = useState("");
  const [loading, setLoading] = useState(false);

  // 获取 CIF 数据，并生成 data URL（代替 Blob URL）
  useEffect(() => {
    if (!materialId) return;

    let isMounted = true;
    setLoading(true);

    axios.get(`/api/download/${materialId}`, { responseType: 'text' })
      .then((res) => {
        if (!isMounted) return;

        // Axios 已经把内容放在了 res.data 里
        const text = res.data;
        setCifContent(text);

        // 生成 data URL
        const dataUrl = "data:chemical/x-cif;charset=utf-8," + encodeURIComponent(text);
        setCifUrl(dataUrl);
      })
      .catch((error) => {
        console.error("Error fetching CIF file:", error);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [materialId]);


  // 初始化 Jmol，加载生成的 data URL
  useEffect(() => {
    if (cifUrl && window.Jmol) {
      setTimeout(() => {
        const jmolScript = `
          load "${cifUrl}" {2 2 2};
          spacefill 20%;
          wireframe 0.15;
          set perspectiveDepth on;
          set axes on;
          set boundingBox on;
          set unitcell on;
        `;

        // 创建 Jmol applet 对象
        const jmolApplet = window.Jmol.getApplet("jmolApplet", {
          width: 900,
          height: 600,
          j2sPath: "https://chemapps.stolaf.edu/jmol/jsmol/j2s",
          use: "HTML5",
          script: jmolScript,
          debug: false,
        });

        // 将 Jmol applet 渲染到页面指定容器中
        const container = document.getElementById("jsmol_container");
        if (container) {
          container.innerHTML = window.Jmol.getAppletHtml(jmolApplet);
        }
      }, 200);
    }
  }, [cifUrl]);

  // 下载 CIF 文件
  const handleDownload = async () => {
  setLoading(true);
  try {
    // 🌟 1. 全面换成 axios，走相对路径
    // 🌟 2. 极其关键：加上 responseType: 'blob'，告诉 axios 我们要下载文件流
    const response = await axios.get(`/api/download/${materialId}`, {
      responseType: 'blob'
    });

    // 🌟 3. 使用 URL.createObjectURL 直接把二进制流变成一个本地临时下载链接
    const url = URL.createObjectURL(response.data);

    // 模拟点击下载
    const a = document.createElement("a");
    a.href = url;
    a.download = `${materialId}.cif`; // 设定下载的文件名
    document.body.appendChild(a);
    a.click();

    // 🌟 4. 打扫战场：移除节点并释放内存
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error downloading CIF file:", error);
    // 这里可以加一个 alert 提示用户下载失败
    alert("下载失败，请检查网络或登录状态！");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container">
        <h2>Crystal Structure Viewer</h2>
        <div id="jsmol_container"></div>
        <div>
            <button className={"page-button"} onClick={handleDownload} disabled={loading}>
                {loading ? "Downloading..." : "Download .CIF"}
            </button>
            <p>
                <strong>Material ID:</strong> {materialId}
            </p>
            <p>
                <strong>CIF Content:</strong>
            </p>
            <pre className="page-styled-pre">
                {cifContent}
            </pre>
        </div>
    </div>
);
}

export default StructureViewer;
